// extracted by mini-css-extract-plugin
export default {"container":"notes_container__AIFHl","notes":"notes_notes__QgCFD","btn":"notes_btn__zZbFZ"};